import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-reclamation',
  templateUrl: './reclamation.component.html',
  styleUrls: ['./reclamation.component.scss'],
})
export class ReclamationComponent implements OnInit {
  @ViewChild('addCommand', { static: false }) addCommand;
  constructor(public generalService: GeneralService) {}
  typeSelected = '';
  motifs;
  searchUser;
  data = [];
  CRM_DS;
  types = [
    {
      type: 'Livraison',
      Motif: ['Erreur De Changement', 'Retard Livraison'],
    },
    {
      type: 'Paiement ',
      Motif: ['Erreur modalite de paiment', 'facturation'],
    },
    {
      type: 'Produit',
      Motif: ['Emballage', 'Casse', 'Couleur non conforme'],
    },
    {
      type: 'Commande',
      Motif: ['Erreur de commande'],
    },
    {
      type: 'Facturation',
      Motif: ['Erreur de prix', 'Erreur remise', 'Facture non Recu'],
    },
    {
      type: 'Qualite',
      Motif: ['PDT Endomage', 'Date Expiration'],
    },
  ];
  changeMotif() {
    const arr: any = this.types.filter((e) => e.type == this.typeSelected);
    this.motifs = arr[0].Motif;
    console.log(arr);
  }
  searchCmdsByUsers() {
    // TODO Tbre
    this.generalService
      .rechercheTable('API_Reclamation', this.searchUser + ',6')
      .subscribe((res) => {
        this.data = res;
      });
  }
  showAddModal() {
    this.generalService.dialog.open(this.addCommand);
  }
  submit() {
    if (
      this.typeSelected &&
      this.CRM_DS.CRMActivity[0].CRMActivity_Sujet &&
      this.CRM_DS.CRMActivity[0].User_Id &&
      this.CRM_DS.CRMActivity[0].CRMActivity_Sujet &&
      this.CRM_DS.CRMActivity[0].Tiers_code
    ) {
      this.CRM_DS.CRMActivity[0].Xtype = this.typeSelected;
      this.CRM_DS.CRMActivity[0].CRMActivity_Date = new Date();
      this.CRM_DS.CRMActivity[0].CRMActivity_Type = 6;
      this.generalService.postDs(this.CRM_DS).subscribe(
        () => {
          this.generalService.dialog.closeAll();
          this.generalService.dialogSuccess(
            'Recommandation ajouter avec success',
            true
          );
        },
        (err) => {
          this.generalService.dialogSuccess(
            'un problème est survenu veuillez réessayer',
            false
          );
        }
      );
    } else {
      this.generalService.dialogSuccess(
        'Veuillez remplir les champs requis',
        false
      );
    }
  }
  ngOnInit(): void {
    this.generalService.getDS('CRMActivity').subscribe((ds) => {
      this.CRM_DS = ds;
    });
  }
}
